import React, { useEffect } from "react";
import LandingPage from "components/organisms/LandingPage";
import { getToken } from "services/auth.service";
import useItToGetAsrList from "hooks/useItToGetAsrList";

function App() {
  useItToGetAsrList();
  useEffect(() => {
    getToken();    
  }, []);
  return <LandingPage />;
}

export default App;
